import { ICustomField } from '../../../interfaces/ICustomField'
import { VistorStatusTypeArray } from '../../../interfaces/IKioskVisitor'

export namespace KioskConstants {
  /**
   * Custom settings fields
   */
  export const KIOSK_CUSTOM_FIELDS: ICustomField[] = [
    {
      label: 'Existing visitor (update the visitor status with new application)',
      type: 'list',
      fields: [
        {
          label: 'Current Status',
          name: 'current_status',
          type: 'select',
          options: VistorStatusTypeArray.map(type => {
            return {
              label: type,
              value: type
            }
          }) as any
        },
        {
          label: 'New Status',
          name: 'new_status',
          type: 'select',
          options: VistorStatusTypeArray.map(type => {
            return {
              label: type,
              value: type
            }
          }) as any
        }
      ]
    }
  ]
}
